import React from 'react';
import Fade, {FadeProps} from '@material-ui/core/Fade';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Typography from '@material-ui/core/Typography';
import {SPRING_1} from '../../colors';

interface AuthSuccessProps extends FadeProps {
    message: string;
}

export default function AuthSuccess({message, ...props}: AuthSuccessProps) {
    return (
        <Fade
            {...props}
            timeout={750}
            style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div>
                <div style={{display: 'block'}}>
                    <div style={{width: '100%', textAlign: 'center'}}>
                        <CheckCircleOutlineIcon
                            style={{fontSize: 120, color: SPRING_1}}
                        />
                    </div>
                    <div>
                        <Typography variant='h4' color='primary'>
                            {message}
                        </Typography>
                    </div>
                </div>
            </div>
        </Fade>
    );
}
